module.exports = __webpack_public_path__ + "img/xny10.5c7e3daa.png";